import { createContext } from 'react';
import 'xstate';
import '../StateMachine/MetricFormMachine';
import { createMemoizedContextData } from '../../../../context/Utils';
export var MetricMachineContext = createContext({});
export var createMemoizedMetricMachine = function (interpreter) {
    return createMemoizedContextData(interpreter);
};
